﻿module.exports = require('./dist/cjs/utils/index');
